/** @module BusinessPlanning/QueryFilterController */
define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/prefs",
	"csi/reflection",
	"csi/xml",
	"Apparel/QueryFilterController"
], function(array,declare,prefs,reflection,xml,QueryFilterController) {

	return declare(QueryFilterController,{
		/**
		 * @override
		 * Gets type for query search from BusinessCategory node
		 */
		onStart: function() {
			var categoryFilterType = this._getFilterType();
			if(categoryFilterType){
				this.queryFilterStartType = xml.enumGetText(categoryFilterType);
				this.queryFilterType = this.queryFilterStartType;
			}
		},

		_getFilterType: function() {
			// summary: return BusinessCategory FilterType for query search
			return this.getNode().FilterType;
		}
	});
});
